export const icons = {
  google: "/assets/img/meetings/google.png",
  zoom: "/assets/img/meetings/zoom.png",
  teams: "/assets/img/meetings/teams.png",
};

export const platformLogo = (platform) => icons[platform];

export const notetakerRelease = 1749427200; // 2025-06-09

export const completedPlgStage = (stage, $userStore) =>
  !!$userStore?.plgStages?.find((s) => s.plgStageId === stage);

export const highlightSearch = (text, search) => {
  if (!search) {
    return [{ text, highlight: false }];
  }
  const escapedSearch = search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(`\\b(${escapedSearch})`, "gi");
  return text.split(regex).map((part) => ({
    text: part,
    highlight: regex.test(part),
  }));
};

export const MEETING_PRIVACY_SETTING_OPTIONS = {
  attendeesOnly: {
    id: "attendeesOnly",
    label: "Only visible to me",
    tagLabel: "Only visible to me",
    icon: "far fa-eye-slash",
    availability: "admins",
  },
  adminsAndAttendees: {
    id: "adminsAndAttendees",
    label: "Only visible to admins",
    tagLabel: "Only visible to admins",
    icon: "far fa-eye-slash",
    availability: "everyone",
  },
  public: {
    id: "public",
    label: "Visible to everyone",
    tagLabel: "Public",
    icon: "far fa-eye",
    availability: "everyone",
  },
};

export const countPendingUpdates = (extractedFields) =>
  // Count pending meeting updates that have non-empty fields
  extractedFields
    ? Object.values(extractedFields)
        .flat()
        .filter(
          (x) => x.status === "pending" && Object.keys(x.fields || {}).length,
        ).length
    : 0;
